<!-- <p>user-additional-details works!</p> -->

<section>
  <div
    [ngClass]="{
      'user-additional-details-container':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'user-additional-details-container-mobile':
        screenSize == ScreenType.Mobile
    }"
  >
    <mat-card>
      <mat-card-header>{{
        "user registration details " | uppercase
      }}</mat-card-header>
      <mat-card-content>
        <div *ngIf="!isDataFilled" class="loading-spinner">
          <mat-spinner></mat-spinner>
        </div>
        <div *ngIf="isDataFilled" class="user-additional-details-content">
          <div *ngIf="false" class="user-additional-details-message">
            Hello {{ "NAME" }}, please upload the details to verify yourself.
          </div>
          <mat-stepper [linear]="false" #stepper>
            <mat-step [stepControl]="userFaceIdForm" [editable]="false">
              <ng-template matStepLabel>UPLOAD IDENTITY</ng-template>
              <form [formGroup]="userFaceIdForm">
                <div class="user-identity-photos-upload">
                  <mat-grid-list
                    [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
                    rowHeight="70px"
                    gutterSize="15px"
                  >
                    <mat-grid-tile rowspan="4">
                      <div class="user-additional-detail-image-container">
                        <img [src]="urlID" alt="Upload ID" />
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="screenSize == ScreenType.Mobile"
                      ><label for="idpic" class="upload-button-label"
                        >Upload ID</label
                      >
                      <input
                        style="display: none"
                        id="idpic"
                        formControlName="photoID"
                        (change)="onUploadID($event)"
                        type="file"
                        name=""
                    /></mat-grid-tile>
                    <mat-grid-tile rowspan="4"
                      ><div class="user-additional-detail-image-container">
                        <img [src]="urlProfile" alt="Upload picture" /></div
                    ></mat-grid-tile>
                    <mat-grid-tile *ngIf="screenSize != ScreenType.Mobile"
                      ><label for="idpic" class="upload-button-label"
                        >Upload ID</label
                      >
                      <input
                        style="display: none"
                        id="idpic"
                        formControlName="photoID"
                        (change)="onUploadID($event)"
                        type="file"
                        name=""
                    /></mat-grid-tile>
                    <mat-grid-tile
                      ><label for="profilepic" class="upload-button-label"
                        >Upload Picture</label
                      >
                      <input
                        style="display: none"
                        id="profilepic"
                        formControlName="profilePic"
                        (change)="onUploadProfile($event)"
                        type="file"
                        name=""
                    /></mat-grid-tile>
                    <mat-grid-tile
                      *ngIf="showMsg && !isAPIRequest"
                      [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                    >
                      <div
                        [ngStyle]="
                          isFaceMatched
                            ? { background: 'green' }
                            : { background: 'red' }
                        "
                        class="display-message"
                      >
                        {{
                          error
                            ? (faceMatchMsg | titlecase)
                            : isFaceMatched
                            ? ("Face matched and status verified" | titlecase)
                            : ("Face did not matched! please retry" | titlecase)
                        }}
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile
                      *ngIf="isAPIRequest"
                      [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                      ><mat-spinner [diameter]="64"></mat-spinner
                    ></mat-grid-tile>
                    <mat-grid-tile
                      *ngIf="!isAPIRequest"
                      [colspan]="
                        isRetry
                          ? '1'
                          : screenSize == ScreenType.Mobile
                          ? '1'
                          : '2'
                      "
                    >
                      <button
                        [disabled]="userFaceIdForm.invalid || isFaceMatched"
                        (click)="onClickVerify(stepper)"
                        mat-raised-button
                      >
                        {{ isRetry ? "Retry" : "Verify" }}
                      </button></mat-grid-tile
                    >
                    <mat-grid-tile *ngIf="isRetry && !isAPIRequest">
                      <button (click)="stepper.next()" mat-raised-button>
                        Next
                      </button></mat-grid-tile
                    >
                  </mat-grid-list>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="userDetailsPass" [editable]="false">
              <div class="user-additional-detail-form">
                <form [formGroup]="userDetailsPass">
                  <mat-grid-list
                    [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
                    rowHeight="80px"
                    [gutterSize]="
                      screenSize == ScreenType.Mobile ? '10px' : '25px'
                    "
                  >
                    <mat-grid-tile>
                      <mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>User ID</mat-label>
                        <input matInput formControlName="userId" />
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>First Name</mat-label>
                        <input
                          matInput
                          formControlName="firstname"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Last Name</mat-label>
                        <input
                          matInput
                          formControlName="lastname"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Username</mat-label>
                        <input
                          matInput
                          formControlName="userName"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Email</mat-label>
                        <input
                          readonly
                          matInput
                          formControlName="email"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Contact Number</mat-label>
                        <input
                          readonly
                          matInput
                          formControlName="phone"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile rowspan="2">
                      <mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Address</mat-label>

                        <textarea
                          formControlName="address"
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="5"
                          cdkAutosizeMaxRows="5"
                          matInput
                        ></textarea>
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Role</mat-label>
                        <input
                          style="text-transform: uppercase"
                          readonly
                          matInput
                          formControlName="role"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        hideRequiredMarker
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>User Status</mat-label>
                        <input
                          readonly
                          matInput
                          formControlName="status"
                        /> </mat-form-field
                    ></mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        subscriptSizing="dynamic"
                        appearance="outline"
                        hideRequiredMarker
                      >
                        <mat-label>Date of Birth</mat-label>
                        <input
                          matInput
                          readonly
                          formControlName="dateOfBirth"
                          [matDatepicker]="Datepicker"
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="Datepicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #Datepicker></mat-datepicker>
                      </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile
                      ><mat-form-field
                        subscriptSizing="dynamic"
                        appearance="outline"
                        hideRequiredMarker
                      >
                        <mat-label>Gender</mat-label>
                        <mat-select formControlName="gender">
                          <mat-option value="male">Male</mat-option>
                          <mat-option value="female">Female</mat-option>
                          <mat-option value="other">Other</mat-option>
                        </mat-select>
                      </mat-form-field></mat-grid-tile
                    >
                  </mat-grid-list>
                </form>
              </div>
              <mat-divider></mat-divider>

              <div style="margin-top: 10px">
                <mat-grid-list cols="3" rowHeight="80px" gutterSize="25px">
                  <mat-grid-tile colspan="3">
                    <button
                      [disabled]="userDetailsPass.invalid"
                      (click)="onSaveUserDetails(stepper)"
                      class=""
                      mat-raised-button
                    >
                      Save
                    </button></mat-grid-tile
                  >
                </mat-grid-list>
              </div>
            </mat-step>
            <mat-step [editable]="false">
              <div class="user-details-last-step">
                <div *ngIf="isShowMsg">
                  {{ error | titlecase }}
                </div>
                <div *ngIf="!isShowMsg"><mat-spinner></mat-spinner></div>
              </div>
            </mat-step>
          </mat-stepper>
        </div>
      </mat-card-content>

      <mat-card-actions *ngIf="!offsetFlag"></mat-card-actions>
    </mat-card>
  </div>
</section>
